/**
 * Baseline deployment history – persisted when deploying scripts from
 * StandardPoliciesView / BuntuDashboard. Used by PerCollectionSummary.
 */
export const STORAGE_BASELINE_DEPLOYMENTS = 'uem_baseline_deployments';

export interface BaselineDeploymentRecord {
  id: string;
  scriptId: string;
  scriptTitle: string;
  targetType: string;
  targetId: string;
  targetName: string;
  deviceIds: string[];
  timestamp: string;
  successCount: number;
  errorCount: number;
}

export function loadBaselineDeployments(): BaselineDeploymentRecord[] {
  try {
    const raw = localStorage.getItem(STORAGE_BASELINE_DEPLOYMENTS);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveBaselineDeployment(record: Omit<BaselineDeploymentRecord, 'id'>): void {
  const list = loadBaselineDeployments();
  const newRecord: BaselineDeploymentRecord = {
    ...record,
    id: `deploy-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  };
  list.unshift(newRecord);
  // Keep last 500 deployments
  const trimmed = list.slice(0, 500);
  localStorage.setItem(STORAGE_BASELINE_DEPLOYMENTS, JSON.stringify(trimmed));
}

export function getTargetDisplayName(targetId: string): string {
  if (targetId.startsWith('plat-')) {
    const name = targetId.replace('plat-', '');
    return name.charAt(0).toUpperCase() + name.slice(1);
  }
  return targetId;
}
